// @flow strict

import * as React from 'react';
import useInfiniteLoader from './useInfiniteLoader';

type Props = {|
  /** the number of milliseconds between scroll events */
  throttle?: number,

  /** The number of pixels that the sentinel is away from the container that will trigger the callback */
  threshold: number,

  /** Should we still keep loading */
  hasMore: boolean,

  /** Callback function to load the next page */
  loadMore: () => Promise<*>,

  /** Should it start loading on mount? */
  infiniteLoadOnMount: boolean,

  /**
   * Set containerRef to the containing modal, or don't set it and this component will use the window.
   * Set sentinelRef to a sentinel div placed several before the last element. see storybook for example
   */
  children: (React.ElementRef<*>, React.ElementRef<*>, () => mixed, boolean) => React.Node,
|};

/**
 * Infinite Loader component that checks when contentRef is about to intersect with containerRef, and calls the callback function.
 */
const InfiniteLoader = ({
  hasMore,
  threshold,
  throttle,
  loadMore,
  infiniteLoadOnMount,
  children,
}: Props) => {
  const containerRef = React.useRef(null);
  const contentRef = React.useRef(null);
  const [isEnabled, enable] = React.useState(infiniteLoadOnMount);
  useInfiniteLoader(contentRef, containerRef, loadMore, hasMore, isEnabled, threshold, throttle);
  return children(containerRef, contentRef, () => enable(true), isEnabled);
};

InfiniteLoader.defaultProps = {
  throttle: 200,
};

export default InfiniteLoader;
export { useInfiniteLoader };
